// Copy for the About page. Founder bio, story, principles and "why partner" are carried over
// verbatim from the previous About page (only "DS 360" normalised to "DS360").

export const glance = [
  { label: 'Company', value: 'DS360 Investment' },
  { label: 'Focus', value: 'Real estate investment & community development' },
  { label: 'Based in', value: 'West Orange, New Jersey' },
  { label: 'Leadership', value: 'Sammy Dutta, Founder & CEO' },
];

export const founder = {
  name: 'Sammy Dutta',
  role: 'Founder & CEO',
  bio: [
    'Hello, my name is Sammy Dutta, and I bring over 20 years of experience in the finance domain, specializing in asset management and investment strategy. I hold an MBA in Marketing and IT and have spent much of my career in the U.S. Finance industry, where I’ve worked in progressive roles including tester, quality assurance analyst, and currently serve as Vice President of Quality Assurance for investment management applications at one of the largest banks in the country.',
    'In my current role, I focus on ensuring the quality and efficiency of investment management systems that support multi-billion-dollar portfolios. My expertise spans across risk management, compliance, and data analytics—all of which play a crucial role in identifying high-value investment opportunities and ensuring operational excellence.',
    'As I transition into real estate investment, I am excited to leverage my extensive background in asset management, risk assessment, and market analysis to identify and execute profitable real estate ventures. I’m eager to collaborate with fellow investors and bring data-driven strategies, rigorous due diligence, and a disciplined investment approach to the real estate market, particularly in urban redevelopment opportunities.',
  ],
  facts: [
    { label: 'Experience', value: '20+ years in finance & investment' },
    { label: 'Current role', value: 'VP, Quality Assurance' },
    { label: 'Education', value: 'MBA, Marketing & IT' },
  ],
  quote: 'Together, we’re not just investing in buildings—we’re investing in lasting impact.',
};

export const story = {
  vision:
    'At DS360 Investment, my vision is simple—to create opportunities that benefit both our investors and the communities we serve.',
  paragraphs: [
    'Real estate has always been part of my life. I grew up watching my father build developments that still stand tall today in India, and I carry that legacy of durability and integrity into every project we take on.',
    'My professional career in finance and technology taught me the importance of precision, transparency, and accountability—values that are now at the heart of DS360 Investment. I believe investors deserve not only strong returns but also the confidence that their capital is being managed with care, strategy, and purpose.',
    'Through DS360, I’m committed to transforming underutilized properties into vibrant assets, while offering our partners clear structures, risk-managed strategies, and the chance to be part of something meaningful. Every investment decision we make is grounded in rigorous analysis, market intelligence, and a commitment to sustainable growth.',
  ],
  invitation:
    'Together, we’re not just investing in buildings—we’re investing in communities. We’re creating jobs, revitalizing neighborhoods, and building value that extends far beyond financial returns. I invite you to join us on this journey.',
};

export const whatWeDo =
  'DS360 Investment brings investors and real estate opportunity together. We source, structure and deliver the investment, so you can choose how you want to participate while we handle the work in between.';

export const whyPartner =
  'Our approach combines institutional-grade investment discipline with entrepreneurial agility. We understand that sophisticated investors seek more than just returns—they seek partnership, transparency, and alignment of interests. At DS360 Investment, we structure every opportunity with these principles at the forefront, ensuring that our success is inherently tied to yours.';

export const principles = [
  {
    title: 'Disciplined strategy',
    text: 'Every investment undergoes rigorous due diligence, financial modeling, and risk assessment before execution.',
  },
  {
    title: 'Transparent communication',
    text: 'Regular updates, clear reporting, and open dialogue ensure investors remain informed throughout the investment lifecycle.',
  },
  {
    title: 'Community impact',
    text: 'Our projects create lasting value by revitalizing neighborhoods and contributing to sustainable urban development.',
  },
];
